import { Observable } from 'rxjs'
import { MenuItemTypeModel } from '../models/component.model'
import { BaseService } from '../services/base.service'

export abstract class ComponentsRepository extends BaseService {
	abstract GetMenuItem(): Observable<MenuItemTypeModel[]>
}
